export default __webpack_public_path__ + "images/ua-67a46bf793e26237ace0ff44b2eff6b6.svg";